import { render, staticRenderFns } from "./Newsdetail.vue?vue&type=template&id=b1a86232&scoped=true"
import script from "./Newsdetail.vue?vue&type=script&lang=js"
export * from "./Newsdetail.vue?vue&type=script&lang=js"
import style0 from "./Newsdetail.vue?vue&type=style&index=0&id=b1a86232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a86232",
  null
  
)

export default component.exports